<template>
    <div class="current-plans-wrapper" v-if="Object.keys(currentPlanHash).length > 0">
        <div class="current-plans-wrapper-title">{{ $t("billing.currentPlans") }}</div>
        <div class="current-plans-wrapper-content">
            <PlanItem
                v-for="key in Object.keys(currentPlanHash)"
                :key="key"
                :type="key"
                :currentPlans="currentPlanHash[key]"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import PlanItem from "./PlanItem.vue";

export default {
    name: "CurrentPlans",
    components: { PlanItem },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            plans: (state) => state.site.plans,
            currentPlans: (state) => state.site.currentPlans,
        }),
        currentPlanHash() {
            const planHash = _.keyBy(this.plans, "_id");
            const currentPlans = this.currentPlans.filter((currentPlan) => {
                const plan = planHash[currentPlan.planId];
                const ignoreTypes = ["extra-package", "feature"];
                return plan && !ignoreTypes.includes(plan?.type);
            });
            const currentPlanHash = currentPlans.reduce((acc, currentPlan) => {
                const plan = planHash[currentPlan.planId];
                if (!acc[currentPlan.planType]) {
                    acc[currentPlan.planType] = [];
                }
                acc[currentPlan.planType].push({
                    plan,
                    currentPlan,
                });
                return acc;
            }, {
                "supsis": null,
                "chatbot": null,
                "customer-tables": null,
                "automation": null,
                "mail": null,
                "tasks": null,
                "form": null,
                "whatsapp": null,
                "whatsapp-business": null,
                "instagram": null,
                "messenger": null,
                "linkedin": null,
                "telegram": null,
                "meta-lead": null,
                "trendyol": null,
                "webphone": null,
            });
            return Object.keys(currentPlanHash).reduce((acc, key) => {
                if (currentPlanHash[key]) acc[key] = currentPlanHash[key];

                return acc;
            }, {});
        },
    },
};
</script>
<style lang="scss" scoped>
.current-plans-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    padding: 20px;

    &-title {
        font-size: 20px;
        font-weight: 600;
        color: #1C1B1F;
    }

    &-content {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(315px, 1fr));
        grid-gap: 10px;
        background: #F1F4F7;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 10px;
    }
}
</style>
